import { DocDfeAtor, DocDfeAtorPapel, DocDfeAtorTipoIdentificador } from './types'
import { baseVueI18n } from '@/plugins/vue-i18n'
import { BaseTableEntities } from '@/types'

function dfeXmlInscricaoFormat(inscricao: string, atores: DocDfeAtor[], papel: DocDfeAtorPapel): string {
  if (inscricao) {
    const tipoIdentificador = (inscricao.length === 14) ? DocDfeAtorTipoIdentificador.CNPJ : DocDfeAtorTipoIdentificador.CPF
    const ator = atores.find(
      (ator) => (ator.papel === papel) && (ator.tipoIdentificador === tipoIdentificador) && (ator.identificador === inscricao) && ator.nome
    )

    return ator ? `${ator.nome} | ${ator.identificador}` : inscricao
  }
  else return inscricao
}

const docTables: BaseTableEntities = {
  dfeXml: [
    {
      value: 'dataHora',
      text: '',
      formatter: (value, rootValue) => ((value !== undefined) && (value !== null))
        ? `${baseVueI18n.d(new Date(value), { dateStyle: 'short', timeStyle: 'medium', timeZone: rootValue.timeZoneOffset })} ${rootValue.timeZoneOffset}`
        : value
    },
    {
      value: 'timeZoneOffset',
      text: '',
      hidden: true
    },
    {
      value: 'inscricaoEmitente',
      text: '',
      formatter: (value, rootValue) => dfeXmlInscricaoFormat(value, rootValue.atores, DocDfeAtorPapel.EMITENTE)
    },
    {
      value: 'inscricaoDestinatario',
      text: '',
      formatter: (value, rootValue) => dfeXmlInscricaoFormat(value, rootValue.atores, DocDfeAtorPapel.DESTINATARIO)
    },
    {
      value: 'inscricaoTransportador',
      text: '',
      formatter: (value, rootValue) => dfeXmlInscricaoFormat(value, rootValue.atores, DocDfeAtorPapel.TRANSPORTADOR),
      auditing: true
    },
    {
      value: 'tamanho',
      text: '',
      auditing: true
    },
    {
      value: 'checksum',
      text: '',
      auditing: true
    },
    {
      value: 'atores',
      text: '',
      hidden: true
    },
    {
      value: 'dependencias',
      text: '',
      hidden: true
    },
    {
      value: 'conteudo',
      text: '',
      hidden: true
    },
    {
      value: 'dataHoraAtZone',
      text: '',
      hidden: true
    }
  ]
}

export default docTables